module.exports = __webpack_public_path__ + "static/img/logo.124f898b.svg";